import * as React from 'react';
import Spinner from '@mos-front-components/public/es/components/Spinner/Spinner';
import { SPECIAL_VALUE } from '../../../../helpers/address';

interface Suggestion {
  value: string | number;
  text?: string;
}

function renderOrganizationSuggestion(suggestion: Suggestion): JSX.Element {
  switch (suggestion.value) {
    case SPECIAL_VALUE.notFound: {
      return (
        <div className="PguFormSelect_option__disabled">{suggestion.text}</div>
      );
    }
    case SPECIAL_VALUE.error: {
      return (
        <div className="PguFormSelect_option__error">{suggestion.text}</div>
      );
    }
    case SPECIAL_VALUE.retry:
    case SPECIAL_VALUE.switchToManual: {
      return (
        <div className="PguFormSelect_option__link">
          <span className="mos-link">{suggestion.text}</span>
        </div>
      );
    }
    case SPECIAL_VALUE.loading: {
      return (
        <div className="PguFormSelect_option__loading">
          <Spinner />
        </div>
      );
    }
    default: {
      return <span>{suggestion.text}</span>;
    }
  }
}

export default renderOrganizationSuggestion;
